import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { AddonStatus } from '../model/types';

export const GET_CHAT_APP_STATUS = 'chat-settings.state.GET_CHAT_APP_STATUS' as const;

export type GetChatAppStatus = {
	type: typeof GET_CHAT_APP_STATUS;
	meta: {
		analyticsEvent: UIAnalyticsEvent;
	};
};

export const getChatAppStatus = (analyticsEvent: UIAnalyticsEvent): GetChatAppStatus => ({
	type: GET_CHAT_APP_STATUS,
	meta: { analyticsEvent },
});

export const GET_CHAT_APP_STATUS_FAILURE =
	'chat-settings.state.GET_CHAT_APP_STATUS_FAILURE' as const;

export type GetChatAppStatusFailure = {
	type: typeof GET_CHAT_APP_STATUS_FAILURE;
	payload: {
		errorMessage: string;
	};
};

export const getChatAppStatusFailure = (errorMessage: string): GetChatAppStatusFailure => ({
	type: GET_CHAT_APP_STATUS_FAILURE,
	payload: {
		errorMessage,
	},
});

export const LOAD_CHAT_SETTINGS_PAGE = 'chat-settings.state.LOAD_CHAT_SETTINGS_PAGE' as const;

export type LoadChatSettingsPage = {
	type: typeof LOAD_CHAT_SETTINGS_PAGE;
	payload: {
		addonStatus: AddonStatus;
	};
};

export const loadChatSettingsPage = (addonStatus: AddonStatus): LoadChatSettingsPage => ({
	type: LOAD_CHAT_SETTINGS_PAGE,
	payload: {
		addonStatus,
	},
});

export const INSTALL_CHAT_APP = 'chat-settings.state.INSTALL_CHAT_APP' as const;

export type InstallChatApp = {
	type: typeof INSTALL_CHAT_APP;
	meta: {
		analyticsEvent: UIAnalyticsEvent;
	};
};

export const installChatApp = (analyticsEvent: UIAnalyticsEvent): InstallChatApp => ({
	type: INSTALL_CHAT_APP,
	meta: { analyticsEvent },
});

export const INSTALL_CHAT_APP_FAILURE = 'chat-settings.state.INSTALL_CHAT_APP_FAILURE' as const;

export type InstallChatAppFailure = {
	type: typeof INSTALL_CHAT_APP_FAILURE;
	payload: {
		errorMessage: string;
	};
};

export const installChatAppFailure = (errorMessage: string): InstallChatAppFailure => ({
	type: INSTALL_CHAT_APP_FAILURE,
	payload: {
		errorMessage,
	},
});

export type Action =
	| GetChatAppStatus
	| GetChatAppStatusFailure
	| LoadChatSettingsPage
	| InstallChatApp
	| InstallChatAppFailure;
